<template>
  <v-card>
    <v-card-title>
      <span class="headline">Add News</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" sm="12" md="12"> 
            <v-text-field
              v-model="title"
              label="Title of the News"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <date-picker :dateTimeStamp="date" />
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <time-picker :TimeStamp="time" />
          </v-col>

          <v-col cols="12" sm="12" md="12">
            <v-select
              v-model="select"
              :items="items"
              :rules="[(v) => !!v || 'Item is required']"
              label="News Type"
              required
            ></v-select>
          </v-col>

          <v-col cols="12" sm="12" md="12">
            <v-select
              v-model="selected_lang"
              :items="lang_items"
              :rules="[(v) => !!v || 'Item is required']"
              label="Language"
              required
            ></v-select>
          </v-col>

          <v-col
            v-if="this.select === 'Verified News'"
            cols="12"
            sm="12"
            md="12"
          >
            <v-text-field
              v-model="source"
              label="Source of the News"
              hint="State the News reporter company of that verified the News"
            ></v-text-field>
          </v-col>
          <v-col v-if="this.select === 'Fake News'" cols="12" sm="12" md="12">
            <v-text-field
              v-model="source"
              label="Checked by"
              hint="The Company that identified the news to be fake"
              persistent-hint
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-textarea
              name="input-7-1"
              v-model="body"
              label="Body of the News"
              value=""
              hint="Write the entire News"
            ></v-textarea>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-text-field
              label="Image link for the News"
              v-model="imagePath"
              readonly
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <div class="container upload-image-offset">
              <div class="row justify-content-center">
                <div class="col-12"><image-upload :title="upload" /></div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <small>*indicates required field</small>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="this.triggerCloseDialog">
        Close
      </v-btn>
      <v-btn v-if="isUpdate===false" color="blue darken-1" text @click="saveNews"> Save </v-btn>
      <v-btn v-if="isUpdate" color="blue darken-1" text @click="editNews"> Update </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import moment from "moment";
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
import { eventBus } from "@/main.js";
import datePicker from "../shared/components/datePicker";
import timePicker from "../shared/components/timePicker";
import imageUpload from "../shared/components/imageUpload";
export default {
  props: ["lang"],
  async created() {
 
    eventBus.$on("formChangeEvent", (value) => {
      if (value) {
        this.populateNewsForm();
      }
    });
  },
  components: { datePicker, imageUpload, timePicker },
  computed: {
    ...mapFields("news", ["currentTab"]),
    ...mapFields("shared", [
      "imagePath",
      "isUpdate",
      "formPopulator",
      "selectedTime",
      "selectedDate",
      "selectedDateTime",
    ]),
    newsTitle() {
      if (this.formPopulator.title) {
     
        this.title = this.formPopulator.title;
        return this.title;
      }
    },
  },
  data: (vm) => ({
    title: "",
    date: null,
    time: null,
    source: "",
    body: "",
    select: null,
    items: ["Verified News", "Fake News"],
    upload: "upload an image",
    lang_items: ["en", "ar", "am"],
    selected_lang: "en",
  }),
  methods: {
    ...mapActions("news", ["addNews","updateNews", "fetchAllNews", "fetchFakeNews"]),
    ...mapActions("shared", ["setImagePath", "dateTimeSelected"]),
    triggerCloseDialog(value) {
      eventBus.$emit("dialogToggle", false);
    },
    populateNewsForm() {
      // if new form set initial states
      if (this.isUpdate === false) {
        this.title = "";
        this.date = 0;
        this.time = 0;
        this.select = null;
        this.body = "";
        this.source = "";
        this.imagePath = "";
      } else {    
        this.title = this.formPopulator.title;

        this.date = moment(this.formPopulator.date).unix();
        this.time = moment(this.formPopulator.date).unix();
        this.select = this.items[this.currentTab];
        this.body = this.formPopulator.body;
        this.source = this.formPopulator.source;
        this.imagePath = this.formPopulator.image;
        this.selected_lang = this.lang
      }
    },
    async saveNews(form) {
      // Parse string TimeDate as TimeStamp
      var dateTime = this.selectedDate + " " + this.selectedTime;

      var newsType = {
        type: this.select,
      };
      var newsContent = {
        title: this.title,
        date: moment(dateTime).format('LLL') + " UTC+3",
        body: this.body,
        source: this.source,
        image: this.imagePath,
        likes: 0,
        views: 0,
      };
      try {
        this.addNews({
          payload: {
            news: newsContent,
            lang:this.selected_lang,
          },
          payloadType: newsType,
        });
        eventBus.$emit("dialogToggle", false);
        await this.fetchAllNews(this.selected_lang)
        await this.fetchFakeNews(this.selected_lang);
        alert("Successfully Created News!");
      } catch (error) {
        alert("Failed to created News!");
      }
    },
     async editNews(form) {
       var path;
      // Parse string TimeDate as TimeStamp
      var dateTime = this.selectedDate + " " + this.selectedTime;
      // this.dateTimeSelected({
      //   payload: {
      //     datetime: dateTime,
      //   },
      // });

      // check path as verify / fake
      if(this.currentTab === 0){
         path =  "all_news/"; 
      }else{
        path =  "fake_news/"; 
      }
    
      var newsContent = {
        title: this.title,
        date: moment(dateTime).format('LLL') + " UTC+3",
        body: this.body,
        source: this.source,
        image: this.imagePath,
        likes: 0,
        views: 0,
      };
      try {
        this.updateNews({
          payload: {
            news: newsContent,
            lang:this.selected_lang,
          },
          payloadPath: path,
          payloadId: this.formPopulator.id
        });
        eventBus.$emit("dialogToggle", false);
        await this.fetchAllNews(this.selected_lang)
        await this.fetchFakeNews(this.selected_lang);
        alert("Successfully Updated News!");
        // location.reload();
      } catch (error) {
        alert("Failed to update News!");
      }
    }
  }, 
};
</script>